import { useDispatch, useSelector } from 'react-redux'
import { useMemo } from 'react'

export const useActionProps = () => {
  // should use separate selectors for memoization
  const format = useSelector(state => state.data.format)
  const lang = useSelector(state => state.data.lang)
  const viewSize = useSelector(state => state.data.viewSize)
  const categoryCode = useSelector(state => state.data.categoryCode)
  const collectionId = useSelector(state => state.data.collectionId)
  const ids = useSelector(state => state.data.ids)
  const userId = useSelector(state => state.data.userId)
  const term = useSelector(state => state.data.term)
  const ipAddress = useSelector(state => state.data.ipAddress)
  const isMultiQuery = useSelector(state => state.data?.flags?.useAlgolia)

  const dispatch = useDispatch()
  return useMemo(
    () => ({
      format,
      lang,
      viewSize,
      categoryCode,
      collectionId,
      ids,
      userId,
      term,
      ipAddress,
      isMultiQuery,
      dispatch
    }),
    [categoryCode, collectionId, dispatch, format, ids, ipAddress, isMultiQuery, lang, term, userId, viewSize]
  )
}
